/**
 * Runtime Configuration for API Backend URL
 * 
 * This solves the deployment issue where React build-time environment variables
 * get hardcoded into the JavaScript bundle.
 * 
 * Solution: Detect the current domain at runtime and use appropriate backend URL
 */

// Function to get the correct backend URL based on current domain
export const getBackendUrl = () => {
  const hostname = window.location.hostname;
  
  // Production domain - use relative URLs
  if (hostname === 'create3dworks.com' || hostname === 'www.create3dworks.com') {
    return '';
  }
  
  // Development/testing environments
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
  }
  
  // Other environments - check for specific patterns
  if (hostname.includes('preview.')) {
    // Use full URL for preview environments
    const parts = hostname.split('.');
    return `https://${hostname}`;
  }
  
  // Fallback: use environment variable or relative URL
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Export the backend URL for use throughout the app
export const BACKEND_URL = getBackendUrl();
